import { defineFeature } from "../core/composition/define-feature.js";
import { applyStartPosition } from "../behaviors/dom/apply-start-position.js";
//#region src/playback/features/start-position.ts
/** The behaviors the feature composes, in setup order. */
const behaviors = [applyStartPosition];
/** The config defaults the feature contributes. */
const defaultConfig = {};
/** The state values the feature seeds. */
const initialState = {};
/**
* Starts playback at `state.startPosition` instead of zero. Also performs the seeks other features request through
* `state.startPosition`, such as the live edge and the AirPlay session-end restore.
*/
const startPositionFeature = defineFeature({
	behaviors,
	defaultConfig,
	initialState
});
//#endregion
export { behaviors, defaultConfig, initialState, startPositionFeature };
